/* global gtag */

export const trackStoreeelEvent = (eventName, params = {}) => {
  if (typeof gtag !== 'function') return;
  if (window.storeeelGtag === undefined) return;

  const defaultParams = {
    send_to: window.storeeelGtag,
  };

  gtag('event', eventName, {
    ...defaultParams,
    ...params
  });
}
